// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DownloadAbaFileRequestModel from '../../model/download-aba-file-request-model';
import DownloadAbaFileRequestDTO from '../dto/download-aba-file-request-dto';

export default abstract class DownloadAbaFileRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DownloadAbaFileRequestDTO>) {
    super();
    if (data) {
      this.orderId = data.orderId;
      this.employeeId = data.employeeId;
      this.customerId = data.customerId;
      this.orderDateFrom = data.orderDateFrom;
      this.orderDateTo = data.orderDateTo;
      this.orderSentAtFrom = data.orderSentAtFrom;
      this.orderSentAtTo = data.orderSentAtTo;
      this.orderState = data.orderState;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  * @type {int64}
  */
  'orderId'?: number;
  /**
  * @type {int64}
  */
  'employeeId'?: number;
  /**
  * @type {int64}
  */
  'customerId'?: number;
  /**
  * @type {date-time}
  */
  'orderDateFrom'?: string;
  /**
  * @type {date-time}
  */
  'orderDateTo'?: string;
  /**
  * @type {date-time}
  */
  'orderSentAtFrom'?: string;
  /**
  * @type {date-time}
  */
  'orderSentAtTo'?: string;
  /**
  * @type {int32}
  */
  'orderState'?: 0 | 1 | 2 | 3 | 4; // OrderStateDTO
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<DownloadAbaFileRequestDTO>): DownloadAbaFileRequestModel;
  static toModel(dto: DeepPartial<DownloadAbaFileRequestDTO> | undefined | null): DownloadAbaFileRequestModel | undefined;
  static toModel(dto: DeepPartial<DownloadAbaFileRequestDTO> | undefined | null): DownloadAbaFileRequestModel | undefined {
    return dto ? new DownloadAbaFileRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DownloadAbaFileRequestModel> | DownloadAbaFileRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'orderId': unwrapped.orderId,
      'employeeId': unwrapped.employeeId,
      'customerId': unwrapped.customerId,
      'orderDateFrom': unwrapped.orderDateFrom,
      'orderDateTo': unwrapped.orderDateTo,
      'orderSentAtFrom': unwrapped.orderSentAtFrom,
      'orderSentAtTo': unwrapped.orderSentAtTo,
      'orderState': unwrapped.orderState,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as DownloadAbaFileRequestDTO;
  }
}
